import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import {Button, CircularProgress, Grid} from "@mui/material";
import React, {useState} from "react";
import {environment} from "../../../env.ts";
import {MultiTypedSearchComponent} from "../../../components/search/MultiTypedSearchComponent.tsx";
import {CloudDownload, Done, UploadFile} from "@mui/icons-material";
import {analyticsExportEvent} from "../../../services/analytics/AnalyticEvents.ts";
import {downloadAsFile} from "../../../components/download-data-button/DownloadAsFile.ts";
import {contractFileIsValid, contractFileMimeTypes, ContractUploadController} from "../ContractUploadController.ts";
import moment from "moment";

export const ContractHeaderFiltersBarAlt = observer(() => {
    const {contractInsightsStore, authStore, materializedApi} = useStores();
    const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);
    const [hasDownloadedExcel, setHasDownloadedExcel] = useState(false);
    return <>
        {/*Filter*/}
        <Grid container alignItems="center" spacing={2}>
            {environment.isDemo &&
                <Grid>
                    <MultiTypedSearchComponent
                        id="contract-search"
                        manager={contractInsightsStore.searchManager}
                        className="contract-search-component"/>
                </Grid>
            }
            <Grid>
                <Button
                    color="primary"
                    variant="outlined"
                    className="btn-with-circular-progress button-spacing"
                    startIcon={isDownloadingExcel
                        ? <CircularProgress size={14}/>
                        : (hasDownloadedExcel ? <Done/> : <CloudDownload/>)}
                    disabled={isDownloadingExcel}
                    onClick={() => {
                        setIsDownloadingExcel(true)
                        analyticsExportEvent({
                            export_type: 'contract',
                            object_key: 'all',
                            user: authStore.email
                        })
                        const filename = `Mithra Contracts ${moment().format('YYYY-MM-DD')}.xlsx`
                        materializedApi.downloadContractDataExcel(filename)
                            .then(resp => {
                                downloadAsFile(resp, filename);
                                setHasDownloadedExcel(true)
                            })
                            .finally(() => {
                                setIsDownloadingExcel(false)
                            })
                    }}>
                    {isDownloadingExcel ? 'Preparing data' : 'Export all'}
                </Button>
            </Grid>
            <Grid>
                {/*Partial copy of GcpBucketUploadComponent to ensure we can upload a file with 1 click*/}

                <Button
                    disabled={!authStore.hasEditPermission}
                    startIcon={<UploadFile/>}
                    variant="outlined"
                    component="label"
                    className="upload-file-button"
                    onClick={() => {
                        contractInsightsStore.setContractUploadDialogIsOpen(true);
                    }}>
                    Upload contract file
                    <input
                        hidden
                        accept={contractFileMimeTypes}
                        type="file"
                        onChange={(event) => {
                            if (!event.target.files || event.target.files.length !== 1) {
                                ContractUploadController.cancel();
                                return;
                            }
                            const file: File = event.target.files[0];
                            const valid = contractFileIsValid(file);
                            if (!valid) return;

                            // No file validation for contract parser
                            ContractUploadController.handleFileUpload(file);
                        }}
                    />
                </Button>
            </Grid>
        </Grid>
    </>;
})
